/* istanbul ignore file */
import React, { useState, useContext, useEffect } from 'react';
import { Checkbox } from '@catalogo/ui-americanas-desktop-product-review/src/components/atoms';
import { Wrapper, Text } from './Styled';
import { context } from '../../../context';
import { useFilterBook } from '../../../hooks/index';
import { withFilters } from '../../../hocs/withFilters';
import { filterHelp } from '../../../helpers';

interface FilterTypeProps {
  filterVerified: () => void;
  filterSkoob: () => void;
}

const FilterTypes = (props: FilterTypeProps) => {
  const { filterVerified, filterSkoob } = props;
  const { queryParam, dispatchMetrics, config } = useContext<any>(context);
  const { breadcrumb } = config;
  const { isBook } = useFilterBook({ breadcrumb });
  const [compCheck, setCompCheck] = useState<boolean>(false);
  const [skoobCheck, setSkoobCheck] = useState<boolean>(false);

  useEffect(() => {
    if (queryParam?.badges == 'verified_purchaser' || filterHelp(queryParam, 'verified_purchaser')) {
      setCompCheck(true);
    } else {
      setCompCheck(false);
    }
    if (queryParam?.badges == 'skoob' || filterHelp(queryParam, 'skoob')) {
      setSkoobCheck(true);
    } else {
      setSkoobCheck(false);
    }
  }, [queryParam]);

  const isCompChecked = () => {
    filterVerified();
    dispatchMetrics('event:track', {
      category: 'avaliacao-pdp',
      action: 'comprou-e-avaliou',
      label: `filtro ${!compCheck ? 'aplicado' : 'retirado'}`,
    });
    setCompCheck(!compCheck);
  };

  const onClickSkoob = () => {
    filterSkoob();
    dispatchMetrics('event:track', {
      category: 'avaliacao-pdp',
      action: 'resenha-skoob',
      label: `filtro skoob ${!skoobCheck ? 'aplicado' : 'retirado'}`,
    });
    setSkoobCheck(!skoobCheck);
  };

  const skoobFilter = isBook && (
    <Checkbox onClick={onClickSkoob} checked={skoobCheck}>
      resenha skoob
    </Checkbox>
  );

  return (
    <Wrapper>
      <Text>Tipo de avaliação</Text>
      <Checkbox onClick={isCompChecked} checked={compCheck}>
        comprou e avaliou
      </Checkbox>
      {skoobFilter}
    </Wrapper>
  );
};

const TypeOfReview = withFilters(FilterTypes);

export default TypeOfReview;
export { TypeOfReview };
